import { render } from "./MainFooter.vue?vue&type=template&id=f841e9f8&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=f841e9f8&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-f841e9f8"

export default script